// eslint-disable-next-line
export default function sizeInterpolater(labels: any[], originals: any[], now?: string) {
  const index = labels.findIndex((e) => e === now);
  return originals[index];
}
